<h2 class="comp-title" style="margin-bottom: 25px;">Success page</h2>
<div class="success-page">
   <div class="main-title">
     <h1>הקוד הסודי לכרטיס שלי</h1>
   </div>
   <img src="/assets/material/best.svg" alt="" class="success-img">
   <h2>התהליך הושלם בהצלחה</h2>
   <p class="alert-user">
    לא הצלחנו להציג את הקוד הסודי לכרטיסך
    אפשר לנסות שוב עכשיו או בעוד מספר דקות
   </p>
   <div class="button-wrapper">
    <a href="#" class="brand-button aqua-button" title=""><span>אנסה שוב</span></a>
    <a href="#" class="link" title="">חזרה לעמוד הבית</a>
   </div>
</div>